import { useTranslation } from "next-i18next";
import { useAddWatchlistWikifoliosMutation, useRemoveWatchlistWikifoliosMutation } from "src/api/client/watchlist.api";
import { EnumToastStatus, useWfToast } from "src/hooks/use-wf-toast";
import { useUserStore } from "src/stores/user-store";
import { useWikifolioStore } from "src/stores/wikifolio-store";
import { useLinkBuilder } from "../use-link-builder";

export const useWikifolioFollowing = (wikifolioId: string) => {
    const { t } = useTranslation("common");
    const { setOnWatchlist, watchlist, canBeFollowedWikifolios } = useWikifolioStore();
    const toast = useWfToast();
    const { isLoggedIn } = useUserStore();
    const { openLoginModal } = useLinkBuilder();

    const isFollowed = watchlist[wikifolioId];
    const canBeFollowed = canBeFollowedWikifolios[wikifolioId];

    const onError = () => {
        toast({ status: EnumToastStatus.Error, title: t("general-error") });
        setOnWatchlist(wikifolioId, !isFollowed);
    };

    const { mutatePromise: add } = useAddWatchlistWikifoliosMutation(wikifolioId, { onError });
    const { mutatePromise: remove } = useRemoveWatchlistWikifoliosMutation(wikifolioId, { onError });
    const toggleIsFollowed = () => {
        if (!isLoggedIn) {
            openLoginModal();
            return;
        }

        setOnWatchlist(wikifolioId, !isFollowed);

        if (isFollowed) {
            remove();
        } else {
            add({});
        }
    };

    return {
        canBeFollowed,
        isFollowed,
        toggleIsFollowed,
    };
};
